import React, { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import './style.scss';

import { Navigation } from 'swiper/modules';
import ClassesCard from '../classesCard';
import { getAllLocations, getLocationById } from '../../../services/partner.service';
import { setLocations, setUserDetail } from '../../data/redux/user/userSlice';
import { useDispatch, useSelector } from 'react-redux';

export default function MultiColumnSlider({ classes }: any) {
  const locationId = localStorage.getItem('locationId');
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.user);
  useEffect(()=> {
    //
    getUserDetail()
  }, [])

  const getRepeatInfo = (classData: any) => {
    let string = "Once";
    if (
      classData?.classRepeat?.type == "repeat" &&
      classData?.classRepeat?.selection
    ) {
      if (classData?.classRepeat?.selection == "week") {
        string = "Weekly";
      }
      if (classData?.classRepeat?.selection == "day") {
        string = "Daily";
      }
      if (classData?.classRepeat?.selection == "month") {
        string = "Monthly";
      }
    }
    return string;
  };



  const handleClose = () => {
    getUserDetail()
  }
  const getUserDetail = async () => {

    try {
      const [selectedLocation, Loc] = await Promise.all([getLocationById(), getAllLocations()]);
      let array = Loc?.data?.data?.locations;
      let filteredData;
      if (array && Array.isArray(array)) {
        filteredData = array.filter((item: any) => item._id === locationId);
        dispatch(setLocations(filteredData[0]))
      }
      dispatch(setUserDetail(selectedLocation?.data?.data));
    } catch (error) {
      // silently handle
    }
  }

  return (
    <div>
      <Swiper
        slidesPerView={4}
        spaceBetween={24}
        pagination={{
          clickable: true,
        }}
        breakpoints={{
          300: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          575: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
          991: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        }}
        navigation={true}
        modules={[Navigation]}
        className="mySwiperMultiColumn"
      >

        {classes?.length &&
          classes.map((item: any) => (
            <SwiperSlide>
              <ClassesCard
                className={item.className}
                image={item.images[0]}
                status={item.status}
                classType={getRepeatInfo(item)}
                participants={item.participants}
                showImg={false}
                classId={item._id}
                isPaused= {item?.classPause?.type && item?.classPause?.type!="none" ? true : false}
                maxBooking={item?.maxBooking}
                handleClose={handleClose}
                classDetails={item}
                classStatus={item?.classStatus}
              />
            </SwiperSlide>
          ))}
      </Swiper>
    </div>
  );
}
